import Vue from "vue";
import stockReportTransformer from "@/transformers/catalog/warehouse/stockReport";
import moment from "moment";

/**
 * @author jorge nuñez lópez <>
 *
 * Fetch warehouse current stock
 * @return {object}
 */

const paramsTransformer = ({ from, to, warehouse, searchQuery }) => ({
  /* Final Users requested to hide filter date */
  // from: from ? moment(from).format("YYYY/MM/DD") : null,
  // to: to ? moment(to).format("YYYY/MM/DD") : null,
  warehouse,
  text: searchQuery,
});

export default (opts) => {
  const params = opts ? paramsTransformer(opts) : null;

  return Vue.$http
    .get(`iwarehouse/report/stock-warehouse/`, { params })
    .then(({ data }) => {
      const dataTransformed = stockReportTransformer.fetchCollection(data);
      return dataTransformed;
    });
};



// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchStockReport.js